// noinspection AllyPlainJsInspection

import axios from 'axios';
import CebeoService from '@/services/cebeoService/CebeoService';

class AuthService {
  setToken(authToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    return this;
  }

  getAccessToken() {
    const authObject = {
      grant_type: 'client_credentials',
      scope: '*',
      client_id: process.env.VUE_APP_CLIENTID,
      client_secret: process.env.VUE_APP_CLIENTSECRET,
    };

    return CebeoService.doApiCall('post', 'oauth/token', 'getToken', authObject)
      .then((res) => this.setToken(res.access_token));
  }
}

export default new AuthService();
